import { render, staticRenderFns } from "./popoverFontSize.vue?vue&type=template&id=42746004&scoped=true&v-if=actualformular&"
import script from "./popoverFontSize.vue?vue&type=script&lang=js&"
export * from "./popoverFontSize.vue?vue&type=script&lang=js&"
import style0 from "./popoverFontSize.vue?vue&type=style&index=0&id=42746004&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42746004",
  null
  
)

export default component.exports